


























import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import {
  registerEventFromApp,
  listenFromParent,
  sendToParrent,
  ParentEvDataInitRes,
  ParentEvDataOpenRes,
  platform,
  Bridge,
} from '@/common/bridge';
import { onOpenMyRequest, onOpenArticle, onFloatButton, emitFloatButton } from '@/common/eventBus';
import MyRequestComponent from '@/components/MyRequest/index.vue';
import Article from '@/components/Article.vue';
import FloatButton from '@/components/FloatButton.vue';
import { CustomerServiceProvider, MINIMIZE_TIME } from '@/common/config';
import { LoginResult } from './common/types';

const UserModule = namespace('user');

@Component({
  components: {
    MyRequestComponent,
    Article,
    FloatButton,
  },
})
export default class App extends Vue {
  @UserModule.Mutation('initProject') initProject!: Function;
  @UserModule.Mutation('updateLoginStatus') updateLoginStatus!: Function;
  @UserModule.Action('sportyLoginSuccess') sportyLoginSuccess!: Function;

  showFloatButton = false;
  showMyRequest = false;
  fetchArticle = false;
  isFromAutocomplete = false;
  articleTitle = '';
  categoryName = '';
  showArticle = false;
  showArticleId: string|number = '';
  articleBody = '';
  articleSectionTitle = '';
  hasInit = false;

  created () {
    // Interaction
    registerEventFromApp(); // Need to only call once before listenFromParent, it only used for App(handled internally)

    // Listen
    const onLogin = (data: LoginResult) => {
      if (Object.prototype.hasOwnProperty.call(data, 'bizCode')) {
        if (data.bizCode === 10000) {
          this.sportyLoginSuccess(data);
        }
      } else {
        this.sportyLoginSuccess(data);
      }
    };

    Bridge.onLoginFromPopup(onLogin);
    Bridge.onLoginSuccess(onLogin);

    listenFromParent<ParentEvDataOpenRes>('OPEN', async data => {
      emitFloatButton(false);
      sendToParrent('MINIMIZE', {
        period: MINIMIZE_TIME, // sec
        open: true,
      });
    });
    listenFromParent<ParentEvDataInitRes>('INIT', async data => {
      const { open } = data;
      if (!this.hasInit && !open) { // For INIT event like Sportybet web in home page, should also do minimize
        emitFloatButton(true);
      }
      this.initProject({
        ...data,
        provider: CustomerServiceProvider.PLEASED,
      });
      if ((platform === 'wap' || platform === 'web')) {
        if (open) { // For INIT event like Sportybet web in home page, only when open Chatroom/index.vue when it is opened, to reduce API call (ex: /user/createUser, /category/list)
          this.hasInit = true;
        }
      } else { // natvie
        this.hasInit = true;
      }
    });
    // listenFromParent('GO_LIVE_CHAT', (data) => {
    //   this.$router.push({ name: 'chatroom' });
    // });
    sendToParrent('INIT'); // Bridge-INIT-Send
    // For dev test, you can also use demo.html to serve it
    // this.initProject({
    //   isLogin: true,
    //   country: 'ng',
    //   token: 'patron:id:accesstoken:01eaca62e29984eb15ff6ce14ba5c23fUTgQ3/SxSNLupEqlhu0pNH8IL2LfwwB3UjZx3o/P0Ojw2hlJd4vn3toIbcDEuoe73aEyUYj9BgLzA+PcvzyiIA==',
    //   chatStatus: '',
    //   provider: CustomerServiceProvider.PLEASED,
    //   phone: '',
    //   email: '',
    // }); // 7771110000 test1234ng
    // this.hasInit = true;

    onFloatButton(isOpen => {
      this.showFloatButton = (isOpen && (platform === 'wap' || platform === 'web')); // Only mobile web and desktop can use FloatButton
      if (isOpen === false) {
        this.hasInit = true;
      }
    });

    onOpenMyRequest(isOpen => {
      this.showMyRequest = isOpen;
    });
    onOpenArticle(data => {
      this.showArticle = data.isOpen;
      this.showArticleId = data.articleId || '';
      this.articleTitle = data.title || '';
      this.categoryName = data.categoryName || '';
      this.articleBody = data.body || '';
      this.articleSectionTitle = data.sectionTitle || '';
      this.fetchArticle = data.fetchArticle || false;
      this.isFromAutocomplete = data.isFromAutocomplete || false;
    });
  }
}
